<main>
  <caixa-webcomponent-navigation-bar />

  <header
    class="investments-header notification"
  >
    <caixa-webcomponent-main-title text="Linhas de Crédito" [lastUpdate]="lastUpdate" />
  </header>

  <div class="cards-grid">
    <div class="cards-column">
      <div class="cds-card card-item card-total-balance">
        <div class="card-header">
          <h4 class="card-title">
            Saldo devedor total (atual e agrupado)
          </h4>
        </div>

        @if (isLoadingSummary()) {
          <caixa-webcomponent-shimmer
            width="120px"
            height="32px"
            borderRadius="4px"
          />
        } @else {
          <span
            class="card-value"
            [class]="cashIndicatorClass(data.cards.totalOutstandingBalance, 'debit')"
          >R$ {{ signedCash(data.cards.totalOutstandingBalance, 'debit') | formatCash }}</span>
        }
      </div>

      <div class="cards-row">
        <div class="cds-card card-item card-overdue">
          <div class="card-header">
            <h4 class="card-title">Contratos atrasados</h4>
          </div>

          @if (isLoadingSummary()) {
            <caixa-webcomponent-shimmer
              width="60px"
              height="32px"
              borderRadius="4px"
            />
          } @else {
            <span class="card-value negative">{{ data.cards.overdueContracts }}</span>
          }
        </div>

        <div class="cds-card card-item card-active">
          <div class="card-header">
            <h4 class="card-title">Contratos vigentes</h4>
          </div>

          @if (isLoadingSummary()) {
            <caixa-webcomponent-shimmer
              width="60px"
              height="32px"
              borderRadius="4px"
            />
          } @else {
            <span class="card-value positive">{{ data.cards.activeContracts }}</span>
          }
        </div>
      </div>
    </div>

    <div class="cds-card card-item card-institutions">
      <div class="card-header">
        <h4 class="card-title">Saldo Devedor por Instituição Financeira</h4>
      </div>

      <div class="card-content">
        @if (isLoadingSummary()) {
          <caixa-webcomponent-shimmer
            width="100%"
            height="60px"
            borderRadius="8px"
            marginBottom="2px"
            [lines]="3"
          />
        } @else {
          <div class="institutions-list">
            @for (item of data.cards.balanceByInstitution; track item.institution) {
              <div class="institution-item">
                <div
                  class="institution-bar"
                  [style.background-color]="item.color"
                ></div>
                <span class="institution-name">{{ item.institution }}</span>
                <span
                  class="institution-value"
                  [class]="cashIndicatorClass(item.balance, 'debit')"
                >R$ {{ signedCash(item.balance, 'debit') | formatCash }}</span>
              </div>
            } @empty {
              <span>Não encontramos linhas de crédito vinculadas ao seu CNPJ até o momento.</span>
            }
          </div>
        }
      </div>
    </div>

    <div class="cds-card card-item card-credit-lines">
      <div class="card-header">
        <h4 class="card-title">Valor Total por Linhas de Crédito contratadas</h4>
      </div>

      <div class="card-content">
        @if (isLoadingSummary()) {
          <caixa-webcomponent-shimmer
            width="100%"
            height="60px"
            borderRadius="8px"
            marginBottom="2px"
            [lines]="4"
          />
        } @else {
          <div class="credit-lines-list">
            @for (item of data.cards.valueByCreditLine; track item.type) {
              <div class="credit-line-item">
                <div
                  class="credit-line-bar"
                  [style.background-color]="item.color"
                ></div>

                <div class="credit-line-name-container">
                  <span class="credit-line-name">{{ item.type }}</span>
                </div>

                <div class="credit-line-value-container">
                  <span class="credit-line-value">R$ {{ item.value | formatCash }}</span>
                  <i
                    class="cds-icon-filled-question c-icon-strong"
                    [cdsTooltip]="item.tooltip"
                    placement="top"
                  >
                  </i>
                </div>
              </div>
            } @empty {
              <span>Não encontramos linhas de crédito vinculadas ao seu CNPJ até o momento.</span>
            }
          </div>
        }
      </div>
    </div>

    <div class="cds-card card-item card-total-institutions">
      <div class="card-header">
        <h4 class="card-title">Valor Total por Instituição Financeira</h4>
      </div>

      <div class="card-content">
        @if (isLoadingSummary()) {
          <caixa-webcomponent-shimmer
            width="100%"
            height="60px"
            borderRadius="8px"
            marginBottom="2px"
            [lines]="3"
          />
        } @else {
          <div class="total-institutions-list">
            @for (item of data.cards.valueByInstitution; track item.institution) {
              <div class="total-institution-item">
                <div
                  class="total-institution-bar"
                  [style.background-color]="item.color"
                ></div>
                <span class="total-institution-name">{{ item.institution }}</span>
                <span class="total-institution-value">R$ {{ item.value | formatCash }}</span>
              </div>
            } @empty {
              <span>Não encontramos linhas de crédito vinculadas ao seu CNPJ até o momento.</span>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div class="cds-card card-item">
    <div class="tabs-container">
      <caixa-webcomponent-tabs-navigation
        [config]="tabsConfig"
        [activeTab]="activeTab"
        (tabChange)="onTabChange($event)"
      />
    </div>

    <div
      class="table-section"
      [scrollPercent]="25"
      (infiniteScrolling)="onInfiniteScroll()"
    >
      <caixa-webcomponent-data-table
        [data]="tableData"
        [config]="tableConfig"
        [actions]="tableActions"
        [loading]="isLoadingContracts()"
        (sortChange)="onSortChange($event)"
      />
    </div>

    @if (isLoadingMoreContracts()) {
      <caixa-webcomponent-shimmer
        width="100%"
        height="60px"
        borderRadius="8px"
        marginBottom="2px"
        [lines]="3"
      />
    }

    @if (showListEndIndicator) {
      <div class="list-end-indicator">
        <cds-no-content [isListEnd]="true" />
      </div>
    }
  </div>
</main>
